import { useNavigate } from "react-router-dom";
import { homeLink } from "../../../services/cpln";
import { Button } from "antd";
import { PlusCircleOutlined } from "@ant-design/icons";
import { Kind } from "../../../schema/types/base";

interface IProps {
  kind: Kind;
}
export const TableNewItemButton = ({ kind }: IProps) => {
  const navigate = useNavigate();
  return (
    <Button
      type="primary"
      className="action"
      onClick={() => {
        if (["domain"].includes(kind)) {
          navigate(`/console${homeLink(kind)}/-draft`);
          return;
        }
        navigate(`/console${homeLink(kind)}/-create`);
      }}
      iconPosition="end"
      icon={<PlusCircleOutlined />}
    >
      New
    </Button>
  );
};
